export default {
  validation: {
    min: 'Bitte gebe mindestens {min} Zeichen ein',
    max: 'Bitte geben Sie maximal {max} Zeichen ein',
    required: 'Dieses Feld wird benötigt',
    regex: 'Bitte geben Sie gültige Daten ein',
    email: 'Bitte gebe eine gültige E-Mail ein',
    phoneNumber: 'Bitte gebe eine gültige Telefonnummer ein',
    sameValueAs: 'Dieses Feld sollte übereinstimmen mit {sameValueAs}',
    shouldBeTrue: 'Dieses Feld muss angekreuzt werden',
    checked: '',
  },
}
